<mat-card>
  <!-- HEADER -->
  <div class="panel-request__card-header" fxLayout="row wrap" fxLayoutAlign="space-between center">
    <mat-card-title class="panel-request__card-header--title">
      <span [ngClass]="classAttribute"></span>
      {{ state.value | translate }}
    </mat-card-title>
  </div>

  <!-- CONTENT -->
  <mat-card-content>
    <div class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="request-with-detail" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="registerOffice">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.registerOffice</th>
          <td mat-cell class="first-column" class="small-width" *matCellDef="let element">{{ element.regOffice }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="request">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.request</th>
          <td mat-cell class="mid-width" *matCellDef="let element">{{ element.requestNumber }}</td>
          <td mat-footer-cell *matFooterCellDef class="footer-fixed" translate>operationDetail.total.operations</td>
        </ng-container>
        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.clientName</th>
          <td mat-cell class="large-width" *matCellDef="let element">{{ element.customerName }}</td>
          <td mat-footer-cell *matFooterCellDef class="footer-calculated">{{ totalOperations() }}</td>
        </ng-container>
        <ng-container matColumnDef="originAgent">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.originAgent</th>
          <td mat-cell class="small-width" *matCellDef="let element">{{ element.origAgent }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="vendor">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.vendor</th>
          <td mat-cell class="mid-width" *matCellDef="let element">{{ element.seller }}</td>
          <td mat-footer-cell *matFooterCellDef class="footer-fixed" translate>operationDetail.total.financed</td>
        </ng-container>
        <ng-container matColumnDef="investment">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.invest</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">
            {{ element.investment | transformNumber }}
          </td>
          <td mat-footer-cell *matFooterCellDef class="footer-calculated">
            {{ dataSource.data[0].totalFunding | transformNumber }}
          </td>
          <!-- totalFinanced() -->
        </ng-container>
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.product</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.productId }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="article">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.article</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.articleId }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="calification">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.calification</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.brandRating }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="brand">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.brand</th>
          <td mat-cell class="mid-width" *matCellDef="let element">{{ element.brand }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="entrance">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.entrance</th>
          <td mat-cell class="small-width" *matCellDef="let element">{{ element.entryDate }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="resolution">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.resolution</th>
          <td mat-cell class="small-width" *matCellDef="let element">{{ element.resolutionDate }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="payDate">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.payDate</th>
          <td mat-cell class="small-width" *matCellDef="let element">{{ element.paymentDate }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="division">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.division</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.divisionId }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="security">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.security</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.seg }}</td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>
        <ng-container matColumnDef="over">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.over</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.over }}</td>
          <td mat-footer-cell *matFooterCellDef class="footer-fixed" translate>operationDetail.total.tir.average</td>
        </ng-container>
        <ng-container matColumnDef="tir">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.tir</th>
          <td mat-cell class="extra-small-width" *matCellDef="let element">{{ element.tir | transformNumber }}</td>
          <td mat-footer-cell *matFooterCellDef class="footer-calculated">
            {{ dataSource.data[0].halfTir | transformNumber }}
          </td>
        </ng-container>
        <!--TODO: Property not received from Backend -->
        <ng-container matColumnDef="investmentComplement">
          <th mat-header-cell *matHeaderCellDef translate>operationDetail.investmentComplement</th>
          <td mat-cell *matCellDef="let element"></td>
          <td mat-footer-cell *matFooterCellDef></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
